import { Skeleton } from "@mittwald/flow-remote-react-components";

export const StatsSkeleton = () => {
  return (
    <>
      <Skeleton height={"50px"} />
      <Skeleton height={"50px"} />
    </>
  );
};
